export default "__VITE_ASSET__BVS2Dd9$__"